export { CorporativoOnboardingCardIdTelco } from "./CorporativoOnboardingCardIdTelco";
